/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormulaEvaluateColumnDataType } from './FormulaEvaluateColumnDataType';
import {
    FormulaEvaluateColumnDataTypeFromJSON,
    FormulaEvaluateColumnDataTypeFromJSONTyped,
    FormulaEvaluateColumnDataTypeToJSON,
    FormulaEvaluateColumnDataTypeToJSONTyped,
} from './FormulaEvaluateColumnDataType';

/**
 * 
 * @export
 * @interface FormulaEvaluateTableColumn
 */
export interface FormulaEvaluateTableColumn {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    jsonType?: FormulaEvaluateColumnDataType | null;
}



/**
 * Check if a given object implements the FormulaEvaluateTableColumn interface.
 */
export function instanceOfFormulaEvaluateTableColumn(value: object): value is FormulaEvaluateTableColumn {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function FormulaEvaluateTableColumnFromJSON(json: any): FormulaEvaluateTableColumn {
    return FormulaEvaluateTableColumnFromJSONTyped(json, false);
}

export function FormulaEvaluateTableColumnFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaEvaluateTableColumn {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'jsonType': json['jsonType'] === undefined ? undefined : json['jsonType'] === null ? null : FormulaEvaluateColumnDataTypeFromJSON(json['jsonType']),
    };
}

export function FormulaEvaluateTableColumnToJSON(json: any): FormulaEvaluateTableColumn {
    return FormulaEvaluateTableColumnToJSONTyped(json, false);
}

export function FormulaEvaluateTableColumnToJSONTyped(value?: FormulaEvaluateTableColumn | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'jsonType': FormulaEvaluateColumnDataTypeToJSON(value['jsonType']),
    };
}

